import React from "react";
import { Link, useHistory } from "react-router-dom";

import Globe from "../../images/globe.png";

import SigninForm from "../../components/Forms/Signin/Signin";
import SignupClientForm from "../../components/Forms/Signup/Client/Signup";
import SignupTranslatorForm from "../../components/Forms/Signup/Translator/Signup";

import { ArrowDropDown } from "@material-ui/icons";

import Logo from "../../images/logo.svg";

import "./Auth.css";

const Auth = ({ match }) => {
  const history = useHistory();
  const path = match.params.path;
  const hash = window.location.hash;

  const handleAccountType = (type) => {
    if (type === "client") history.push("/auth/signup");
    if (type === "translator") history.push("/auth/signup#translator");
    document.querySelector(".auth__details").removeAttribute("open");
  };

  return (
    <div className="auth d-flex">
      <aside className="auth__left d-flex flex-column align-center container position-sticky t-0">
        <Link to="/">
          <img src={Logo} alt="" />
        </Link>
        <div className="position-relative h-100 d-flex align-center">
          <img className="position-relative" src={Globe} alt="" />
        </div>
      </aside>
      <div className="auth__form w-100 d-flex flex-column justify-center align-center p-40">
        <Link to="/">
          <img className="auth__sm__logo mb-20" src={Logo} alt="" />
        </Link>
        {path !== "signup" && <SigninForm path={path} auth />}
        {path === "signup" && (
          <div className="auth__signup w-100 p-40">
            <div className="d-flex flex-column align-center w-100">
              <h3 className="font-subhead">SIGN UP</h3>
              <p className="font-sm mb-20">
                Fill all the neccessary fields below
              </p>
            </div>
            <div>
              <h3 className="mt-20 mb-40">Account type</h3>
              <div className="mb-40">
                <p className="font-heavy mb-10 ml-5">Type of account</p>
                <details className="auth__details position-relative">
                  <summary className="input d-flex align-center justify-between list-none">
                    <span className="font-bolder font-big text-capitalise">
                      {hash === "#translator" ? "Translator" : "Client"}
                    </span>
                    <ArrowDropDown />
                  </summary>
                  <div className="auth__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                    <div className="d-flex flex-column overflow-auto">
                      <span
                        className="signup__drop__time d-flex flex-column py-10 px-20 border-bottom-1 pointer"
                        onClick={() => handleAccountType("client")}
                      >
                        <span
                          className="font-big font-bold"
                          style={{
                            color: hash !== "#translator" ? "#ff5e15" : "",
                          }}
                        >
                          Client
                        </span>
                        <span>To order for our services</span>
                      </span>
                      <span
                        className="signup__drop__time d-flex flex-column py-10 px-20 border-bottom-1 pointer"
                        onClick={() => handleAccountType("translator")}
                      >
                        <span
                          className="font-big font-bold"
                          style={{
                            color: hash === "#translator" ? "#ff5e15" : "",
                          }}
                        >
                          Translator
                        </span>
                        <span>To become part of our professionals</span>
                      </span>
                    </div>
                  </div>
                </details>
              </div>
            </div>
            {hash !== "#translator" && <SignupClientForm auth />}
            {hash === "#translator" && <SignupTranslatorForm />}
          </div>
        )}
      </div>
    </div>
  );
};

export default Auth;
